import { useState } from "react"
import Modal from 'react-modal';
import useKeypress from "../ownHooks/pressEsc";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyModalButtons, MyModalCloseButton, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { MyCancelButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";

var MonitorApi = require('monitor-api');

export default function ZvUpdate({ rowEntry, instance, reloadData }) {
    const [showModal, setShowModal] = useState(false);
    const [update, setUpdate] = useState(new MonitorApi.ZweckverbandUpdateCommand());
    const [inputs, setInputs] = useState({});
    const [upAvailable, setUpAvailable] = useState(false);
    const [myComment, setMyComment] = useState('');

    const openModal = event => {
        setMyComment(rowEntry.original.kommentar);
        setInputs({
            name: rowEntry.original.name,
            kurz: rowEntry.original.kurz,
            kommentar: rowEntry.original.kommentar
        });
        setUpdate(pre => ({ ...pre, "zvId": rowEntry.original.id }));
        setShowModal(true);
        setUpAvailable(false);
    }

    const closeModal = () => {
        setUpdate({});
        setShowModal(false);
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const changeEntry = event => {
        setUpAvailable(true);
        setUpdate(old => ({ ...old, [event.target.id]: event.target.value }));

        if (event.target.id === 'kommentar') {
            setMyComment(event.target.value);
        }
    }

    const saveChanges = event => {
        event.preventDefault();
        let result = new Promise((resolve) =>
            instance.updateZweckverbandPatch(update, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Änderungen gespeichert`);
                    resolve(data);
                }
            })
        )
        result.then((msg) => {
            closeModal();
            reloadData();
        })
    }

    return (
        <>
            <button onClick={openModal} className="update-bttn">Bearbeiten</button>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={saveChanges}>
                    <h3>Änderungen eintragen:</h3>
                    <MyModalContentRow>
                        <label>Bezeichnung:
                            <MyModalContentTextInput id="name"
                                onChange={changeEntry}
                                value={update.name ? update.name : inputs.name} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Abkürzung:
                            <MyModalContentTextInput id="kurz"
                                onChange={changeEntry}
                                value={update.kurz ? update.kurz : inputs.kurz} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput id="kommentar"
                                onChange={changeEntry}
                                value={myComment}
                            />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit" disabled={!upAvailable}>Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbrechen</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </>

    )
}